import { render, staticRenderFns } from "./WorkOrderColumn.vue?vue&type=template&id=318b2040"
import script from "./WorkOrderColumn.vue?vue&type=script&lang=js"
export * from "./WorkOrderColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports